<!--
    Styles
-->

<style scoped>

    .marker {
        padding: 4px;
        max-width: 200px;
    }
    .marker .index {
        width: 24px;
        height: 24px;
        line-height: 24px;
        border-radius: 50%;
        text-align: center;
        background: var(--cl-orange);
        color: var(--cl-white);
        flex-shrink: 0;
    }
    .marker p {
        padding: 0 4px;
    }

</style>



<!--
    Template
-->

<template>
    <div class="marker arrow-bottom u-row t12 w7">
        <div class="index">{{ index }}</div>
        <p class="u-cut">{{ building.name }}</p>
    </div>
</template>



<!--
    Scripts
-->

<script>

    export default {

        props: [
            'index',
            'building'
        ]

    }

</script>

